<!-- =========================================================================================
    File Name: Main.vue
    Description: Main layout
    ----------------------------------------------------------------------------------------

========================================================================================== -->

<template>
  <div class="layout--main" :class="[layoutTypeClass, navbarClasses, footerClasses, {'no-scroll': isAppPage}]">
    <v-nav-menu
        v-if="isRenderNavBar"
        :navMenuItems = "navMenuItems"
        title         = "お問い合わせ管理"
        parent        = ".layout--admin-main"
        homeUrl = "/" />

    <div id="content-area" :class="[contentAreaClass, {'show-overlay': bodyOverlay}]">
      <div id="content-overlay" />

    <!-- Navbar -->
      <template v-if="mainLayoutType === 'horizontal' && windowWidth >= 1200 && !isEmbedded">
        <the-navbar-horizontal
            :navbarType= "navbarType"
            :class="[
          {'text-white' : isNavbarDark  && !isThemeDark},
          {'text-base'  : !isNavbarDark && isThemeDark}
        ]" />

        <div style="height: 62px" v-if="navbarType === 'static'"></div>

        <h-nav-menu
            :class="[
          {'text-white' : isNavbarDark  && !isThemeDark},
          {'text-base'  : !isNavbarDark && isThemeDark}
        ]"
            :navMenuItems="navMenuItems" />
      </template>
      <template v-else>
        <the-navbar-vertical
          id="tile-container"
          v-if="!isEmbedded"
          :navbarColor="navbarColor"
          :class="[
            {'text-white' : isNavbarDark  && !isThemeDark},
            {'text-base'  : !isNavbarDark && isThemeDark}
          ]" />
      </template>
    <!-- /Navbar -->

      <div id="vs_maincontent" :class="['content-wrapper', { embedded: isEmbedded }]">
        <div class="router-view">
          <div class="router-content">

            <transition :name="routerTransition">

<!--              <div v-if="$route.meta.breadcrumb || $route.meta.pageTitle" class="router-header flex flex-wrap items-center mb-6">-->
<!--                <div-->
<!--                  class="content-area__heading"-->
<!--                  :class="{'pr-4 border-0 md:border-r border-solid border-grey-light' : $route.meta.breadcrumb}">-->
<!--                  <h2 class="mb-1">{{ $t(routeTitle) }}</h2>-->
<!--                </div>-->

                <!-- BREADCRUMB -->
<!--                <vx-breadcrumb class="ml-4 md:block hidden" v-if="$route.meta.breadcrumb" />-->

<!--              </div>-->
            </transition>

            <div class="content-area__content">
              <back-to-top bottom="5%" :right="$vs.rtl ? 'calc(100% - 2.2rem - 38px)' : '30px'" visibleoffset="500" v-if="!hideScrollToTop">
                <vs-button icon-pack="feather" icon="icon-arrow-up" class="shadow-lg btn-back-to-top" />
              </back-to-top>

              <transition :name="routerTransition" mode="out-in">
                <router-view @changeRouteTitle="changeRouteTitle" @setAppClasses="(classesStr) => $emit('setAppClasses', classesStr)" @update_nav_menu="(fn) => fn(navMenuItems)" />
              </transition>
            </div>
          </div>
        </div>
      </div>
      <the-footer />
    </div>
  </div>
</template>


<script>
import BackToTop           from 'vue-backtotop'
import HNavMenu            from '@/layouts/components/horizontal-nav-menu/HorizontalNavMenu.vue'
import TheNavbarHorizontal from '@/layouts/components/navbar/TheNavbarHorizontal.vue'
import TheNavbarVertical   from '@/layouts/components/navbar/TheNavbarVertical.vue'
import TheFooter           from '@/layouts/components/TheFooter.vue'
import themeConfig         from '@/../themeConfig.js'
import VNavMenu            from '@/layouts/components/vertical-nav-menu/VerticalNavMenu.vue'
import navMenuItems        from '@/layouts/components/vertical-nav-menu/userNavMenuItems.js'
import { getLS } from '../../utils/localStorage-utils';
import {mapActions, mapGetters, mapState} from "vuex";
import Cookies from "js-cookie";

export default {
  components: {
    BackToTop,
    HNavMenu,
    TheFooter,
    TheNavbarHorizontal,
    TheNavbarVertical,
    VNavMenu,
  },
  data () {
    return {
      footerType        : themeConfig.footerType  || 'static',
      hideScrollToTop   : themeConfig.hideScrollToTop,
      isNavbarDark      : false,
      navbarColor       : themeConfig.navbarColor || '#fff',
      navbarType        : themeConfig.navbarType  || 'floating',
      navMenuItems,
      routerTransition  : themeConfig.routerTransition || 'none',
      routeTitle        : this.$route.meta.pageTitle,
      isEmbedded        : this.$route.query.mode && this.$route.query.mode == 'sdsk',
      whiteList : ['/']
    }
  },
  watch: {
    $route() {
      this.routeTitle = this.$route.meta.pageTitle
      let activeUser = this.$store.state.AppActiveUser
      let token = sessionStorage.getItem('token') ? sessionStorage.getItem('token') : Cookies.get('rememberLogin');
      if (token && activeUser) {
        if (activeUser.id && !this.whiteList.includes(this.$route.path) ) {
          if (activeUser.enable_chat && activeUser.user_setting.chat_login_id && activeUser.user_setting.chat_login_pass){
            this.countUnreadFaqBbs();
          }
          this.getUnreadNotificationForSys();
        }
      }
    },
    isThemeDark (val) {
      const color = this.navbarColor === '#fff' && val ? '#10163a' : '#fff'
      this.updateNavbarColor(color)
    },
    '$store.state.mainLayoutType' (val) {
      this.setNavMenuVisibility(val)
    },
    "$store.state.loading": function(val) {
        //if (window.document.documentMode) return;
        if(val) this.$vs.loading(
          {
            type:'material'
          });
        else this.$vs.loading.close();
    },
    "$store.state.loads": function(val) {
        //if (window.document.documentMode) return;
        if(val) this.$vs.loading(
          {
            type:'material'
          });
        else this.$vs.loading.close();
    },
    async listMailBox (val) {
      let mailBoxIndex = 2;
      let activeUser = this.$store.state.AppActiveUser;
      if (activeUser.enable_chat){
        mailBoxIndex = 3;
      }
      const lists = val.map(item => Object.assign({}, item));
      if (lists && lists.length > 0) {
        this.navMenuItems[mailBoxIndex].submenu.length = 0;
        let index = 4;
        for (let mailBox of lists) {
          var isSubmenu = false;
          if (this.navMenuItems[mailBoxIndex].url == '/box/'){
            this.navMenuItems[mailBoxIndex].url = `/box/${mailBox.receive_user_name}`;
          }
          this.navMenuItems[mailBoxIndex].level = 2;
          this.navMenuItems[mailBoxIndex].show = true;
        
          if(this.listIndexGroupOpen.indexOf(index) != -1){
            isSubmenu = true;
          }
          let renderedMailBox = this.renderMailBox(mailBox, index, isSubmenu);
          this.navMenuItems[mailBoxIndex].submenu.push(renderedMailBox[0]);
          index = renderedMailBox[1];
        }
      } else {
        this.navMenuItems.splice(mailBoxIndex, 2);
      }
    },
    async listTelephone (val) {
      let telephoneBoxIndex = 2;
      let activeUser = this.$store.state.AppActiveUser;
      if (activeUser.enable_chat ) telephoneBoxIndex++;
      if (this.listMailBox.length > 0) telephoneBoxIndex++

      const lists = val.map(item => Object.assign({}, item));
      if (lists && lists.length > 0) {
        this.navMenuItems[telephoneBoxIndex].submenu.length = 0;
        let index = 100;
        for (let telephoneBox of lists) {
          if (this.navMenuItems[telephoneBoxIndex].url == '/telephone-box/'){
            this.navMenuItems[telephoneBoxIndex].url = `/telephone-box/${telephoneBox.id}`;
          }
          this.navMenuItems[telephoneBoxIndex].level = 2;
          this.navMenuItems[telephoneBoxIndex].show = true;
        
          const result = {
            id: telephoneBox.id,
            name: telephoneBox.name,
            icon: "PhoneIcon",
            url: `/telephone-box/${telephoneBox.id}`,
            slug: "telephone-box",
            level: 3,
            index: index++,
            show: true
          };

          this.navMenuItems[telephoneBoxIndex].submenu.push(result);
          index++
        }
        return
      }
      this.navMenuItems.splice(telephoneBoxIndex, 1);
    },
    unReadFaqBbs: {
      deep: true,
      handler: function(newVal, oldVal) {
        this.navMenuItems[2].unreadNum = newVal;
      }
    },
    unReadNotificationForSys: {
      deep: true,
      handler: function(newVal, oldVal) {
        this.navMenuItems[1].unreadNum = newVal;
      }
    },
  },
  computed: {
    ...mapState(['faqBbs/unReadFaqBbs']),
    ...mapState(['notificationForSys/countUnreadNotificationsForSys']),
    ...mapGetters({
      listMailBox: 'receiveMail/listMailBox',
      listTelephone: 'telephoneServer/listTelephoneFolder',
      listIndexGroupOpen: 'receiveMail/getIndexGroupOpen',
      listMailFolder: 'mailFolder/listMailFolder',
      unReadFaqBbs: 'faqBbs/unReadFaqBbs',
      unReadNotificationForSys: 'notificationForSys/unReadNotificationForSys',
    }),
    bodyOverlay () { return this.$store.state.bodyOverlay },
    contentAreaClass () {
      if(this.isEmbedded || !this.$store.state.activeNavBar) {
        return 'content-area-full'
      }
      else if (this.mainLayoutType === 'vertical') {
        if      (this.verticalNavMenuWidth === 'default') return 'content-area-reduced'
        else if (this.verticalNavMenuWidth === 'reduced') return 'content-area-lg'
        else return 'content-area-full'
      } else return 'content-area-full'
    },
    footerClasses () {
      return {
        'footer-hidden': this.footerType === 'hidden',
        'footer-sticky': this.footerType === 'sticky',
        'footer-static': this.footerType === 'static'
      }
    },
    isAppPage () {
      return this.$route.meta.no_scroll
    },
    isThemeDark ()     { return this.$store.state.theme === 'dark' },
    layoutTypeClass () { return `main-${this.mainLayoutType}`      },
    mainLayoutType ()  { return this.$store.state.mainLayoutType   },
    navbarClasses ()   {
      return {
        'navbar-hidden'   : this.navbarType === 'hidden',
        'navbar-sticky'   : this.navbarType === 'sticky',
        'navbar-static'   : this.navbarType === 'static',
        'navbar-floating' : this.navbarType === 'floating'
      }
    },
    verticalNavMenuWidth () { return this.$store.state.verticalNavMenuWidth },
    windowWidth ()          { return this.$store.state.windowWidth },
    isRenderNavBar() {
      if(this.$route.meta.isHideLeftMenu) return false;

      if (this.isEmbedded) return false;

      if (this.windowWidth >= 1200)
        if (!this.$store.state.activeNavBar) return false;

      return true;
    },
  },
  methods: {
    ...mapActions({
      getListMailBox: 'receiveMail/getListMailBox',
      handleShachihataDeskLogin: 'loginModule/handleShachihataDeskLogin',
      getListMailFolder: 'mailFolder/getListMailFolder',
      getListTelephone: 'telephoneServer/getListTelephoneByAuthFlg',
      saveMailDraft: "mailDraft/saveMailDraft",
      countUnreadFaqBbs: 'faqBbs/countUnreadFaqBbs',
      getUnreadNotificationForSys: 'notificationForSys/getUnreadNotificationForSys',
    }),
    changeRouteTitle (title) {
      this.routeTitle = title
    },
    updateNavbarColor (val) {
      this.navbarColor = val
      if (val === '#fff') this.isNavbarDark = false
      else this.isNavbarDark = true
    },
    setNavMenuVisibility (layoutType) {
      if ((layoutType === 'horizontal' && this.windowWidth >= 1200) || (layoutType === 'vertical' && this.windowWidth < 1200)) {
        this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false)
        this.$store.dispatch('updateVerticalNavMenuWidth', 'no-nav-menu')
      } else {
        this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true)
      }
    },
    checkLogin() {
      // let token = sessionStorage.getItem('token')
    },
    renderMailBox(mailBox, index, isSubmenu) {
      let result = {
        id: mailBox.id,
        name: mailBox.receive_user_name,
        icon: "MailIcon",
        i18n: mailBox.mail_user_name || mailBox.receive_user_name,
        slug: "box",
        level: 3,
        index: index++,
        show: isSubmenu ? true : false,
        submenu: [
          {},
          {
            url: `/spam/${mailBox.receive_user_name}`,
            name: "迷惑メール",
            slug: "mail-spam-list",
            unreadNum: mailBox.numberMailSpamNotSupport,
            loginRequired: true,
          },
          {
            url: `/sent/${mailBox.receive_user_name}`,
            name: "送信",
            slug: "mail-sent-list",
            loginRequired: true,
          },
          {
            url: `/sent-failed/${mailBox.receive_user_name}`,
            name: "送信失敗",
            slug: "mail-sent-failed-list",
            loginRequired: true,
          },
          {
            url: `/draft/${mailBox.receive_user_name}`,
            name: "下書き",
            slug: "mail-draft-list",
            loginRequired: true,
          },
          {
            url: `/sent/${mailBox.receive_user_name}/create-multiple-mail`,
            name: "一斉送信",
            slug: "mail-send-to-multiple",
            loginRequired: true,
          },
          {
              url: `/trash/${mailBox.receive_user_name}`,
              name: "ゴミ箱",
              slug: "mail-trash-list",
              loginRequired: true,
          },
        ],
      };
      let mailReceived = {
        name: "受信",
        url: `/box/${mailBox.receive_user_name}`,
        slug: "mail-box-list",
        unreadNum: mailBox.numberMailNotSupport,
        loginRequired: true,
        redirect: true,
        level: 4,
        canEdit: true,
        index: index++,
        id: 0,
        mail_server: mailBox.receive_user_name,
      };
      //Assign show for current selected received box
      mailReceived.show = window.location.pathname.includes(mailReceived.url);

      //Render submenu
      let level = 5;
      let renderedSubmenu = this.renderSubmenu(mailBox, index, level);
      if (renderedSubmenu[0].length > 0)
        mailReceived.submenu = renderedSubmenu[0];
      index = renderedSubmenu[1];

      //Add subfolder to mailBox
      result.submenu[0] = mailReceived;
      return [result, index++];
    },
    renderSubmenu(mailBox, index, level) {
      function list_to_tree(list, sub = null) {
        var map = {},
          node,
          roots = [],
          i;
        //Initialize the map
        list.map((ele, idx) => {
          list[idx] = {
            id: list[idx].id,
            parent: list[idx].parent,
            name: list[idx].name,
            url: `/box/${mailBox.receive_user_name}/folder/${list[idx].name}`,
            slug: "subfolder",
            canEdit: true,
            index: index++,
            loginRequired: true,
            redirect: true,
            mail_server: mailBox.receive_user_name,
            show: false,
            unreadNum: list[idx].numberMailNotSupport,
          };
          map[list[idx].id] = idx;
        });

        for (i = 0; i < list.length; i += 1) {
          node = list[i];
          if (node.parent != 0) {
            let parent = list[map[node.parent]];
            if (!parent.submenu) {
              parent.submenu = [];
            }
            //Detect the level of subfolder
            node.level = parent.level + 1;
            parent.submenu.push(node);
          } else {
            node.level = level;
            roots.push(node);
          }
        }

        function getURL(node, path) {
          path.push(node.name);
          if (node.parent != 0) {
            return getURL(list[map[node.parent]], path);
          } else {
            return path.reverse().join("/");
          }
        }

        //Get url
        for (i = 0; i < list.length; i += 1) {
          node = list[i];
          let url = getURL(node, []);
          node.url = `/box/${mailBox.receive_user_name}/folder/${url}`;
          node.show = node.show || window.location.pathname.includes(node.url);
        }

        return roots;
      }
      return [list_to_tree(mailBox.subfolder, true), index++];
    },
    async autoSaveMailDraft() {
      if (localStorage.dataSaveDraft) {
        let data = JSON.parse(localStorage.dataSaveDraft)
        localStorage.removeItem("dataSaveDraft");
        await this.onSaveDraft(data)
      }
    },
    async onSaveDraft(data){
      let mailData = {
          body_type    : data.body_type ? 'HTML':'Text',
          to      : data.to,
          from    : data.from,
          subject : data.subject,
          body    : data.body,
          cc      : data.cc,
          bcc     : data.bcc,
          files   : data.files,
          inquiry_type: data.inquiry_type,
          type : data.type,
          mst_user_id: data.mst_user_id,
          mail_type : data.mail_type,
        }
      // For update
      if (data.id) mailData['id'] = data.id;
      if (data.inquiry_type || data.type ||
      data.to.length > 0 || data.cc.length > 0 || data.bcc.length > 0 ||
      data.files.length > 0 || data.subject != '' || data.body != ''){
        localStorage.setItem('noLoading' , true);
        await this.saveMailDraft(mailData)
      }
    },
  },
  mounted(){
    if(this.$route.meta.isHideLeftMenu) {
      let vsContentArea = document.getElementById("content-area");
      let vsNavbar = document.getElementById("vs_navbar");
      let featherIcon = document.getElementById("featherIcon");
      let first = document.querySelector('.vs-con-items > div');

      vsContentArea.style.width = '100%';
      vsNavbar.style.width = '100%';
      featherIcon.classList.remove("sm:inline-flex")
      featherIcon.classList.add("hidden");
      first.classList.remove("pl-3")
    } else {
      window.addEventListener('storage', this.autoSaveMailDraft);
      let activeUser = this.$store.state.AppActiveUser;
      if (!activeUser.enable_chat){
        this.navMenuItems.splice(2, 1)
      }
      let vsContentArea = document.getElementById("content-area");
      if (this.$store.state.activeNavBar) {
        vsContentArea.style.width = "100% - 260px";
      } else {
        vsContentArea.style.width = "100%";
      }
      vsContentArea.style.marginLeft = "0px";
    }
  },
  async created () {
    this.checkLogin()
    if (this.$route.query.mode == 'sdsk' && getLS('postMessage')) {
      await this.handleShachihataDeskLogin();
    }
    if(!this.$route.meta.isHideLeftMenu) {
      const color = this.navbarColor === '#fff' && this.isThemeDark ? '#10163a' : this.navbarColor
      this.updateNavbarColor(color)
      this.setNavMenuVisibility(this.$store.state.mainLayoutType)
      await this.autoSaveMailDraft()
      await this.getListMailBox()
      await this.getListTelephone()
      let vsContentArea = document.getElementById("content-area");
      if (this.$store.state.activeNavBar) {
        vsContentArea.style.width = "100% - 260px";
      } else {
        vsContentArea.style.width = "100%";
      }
      vsContentArea.style.marginLeft = "0px";
      let activeUser = this.$store.state.AppActiveUser;
      if (activeUser.enable_chat && activeUser.user_setting.chat_login_id && activeUser.user_setting.chat_login_pass){
        await this.countUnreadFaqBbs();
        this.navMenuItems[2].unreadNum = this.unReadFaqBbs;
      }
      let notificationForSys = this.$store.state.notificationForSys;
      if (notificationForSys.countUnreadNotificationsForSys){
        await this.getUnreadNotificationForSys();
        this.navMenuItems[1].unreadNum = this.unReadNotificationForSys;
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener("storage", this.autoSaveMailDraft)
  },
};
</script>
<style scoped>
[dir=ltr] #content-area.content-area-lg{
  margin-left: 80px;
}

.embedded .router-view{
  padding: 0!important;
}

.embedded .router-view .router-content {
  padding: 0!important;
  margin-top: 0!important;
}

.embedded #page-send-mail{
  padding-top: 0!important;
}
</style>

